import React from 'react';
import { useSelector } from 'react-redux';
import Authorization from '../authorization';
import Template from './template';

const Layout = () => {
    // const auth = !!localStorage.getItem('token');
    const auth = useSelector(state => state.auth.authorize);

    return (
        <div style={{background: '#141b33', width: '100%'}}>
            {
                !auth &&   <Authorization />
            }
            {
                auth && <Template />
            }
        </div>
    )
}

export default Layout;